import React, {Component, PropTypes} from 'react';
import {Input, Icon} from 'antd'
import {API_ROOT} from '../../../config'

export default class CaptchaInput extends React.Component {
  constructor(props) {
    super(props);

    const value = this.props.value || ''
    this.state = {
      code: value,
      random: ''
    }
  }
  componentWillReceiveProps(nextProps) {
    if ('value' in nextProps) {
      this.setState({code: nextProps.value})
    }
  }
  handleChange = (e) => {
    const code = e.target.value + ''
    this.setState({code})
    this.triggerChange(code)
  }
  triggerChange = (changedValue) => {
    const onChange = this.props.onChange;
    if (onChange) {
      onChange(changedValue)
    }
  }
  getCaptchaHandle = () => {
    this.setState({random: Math.floor(Math.random() * (999 - 1) + 1)})
  }
  render() {
    const {random, code} = this.state
    const {isReSet, placeholder} = this.props
    let placeholderText  = placeholder === undefined ? '请输入验证码' : placeholder

    return (
      <span className="captcha-w">
        <Input
          type="text"
          prefix={<Icon type="key" style={{ fontSize: 13 }} />}
          value={code}
          onChange={this.handleChange}
          style={{ width: '50%', marginRight: '3%' }}
          placeholder={placeholderText}
        />
        <div className="captcha-img-w">
          <img src={`${API_ROOT}/captcha/create?random=${random}${isReSet}`} alt="" />
          <a href="javascript:;" onClick={this.getCaptchaHandle}>换一张</a>
        </div>
      </span>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/common/Captcha/index.js